import React from 'react'
import Navbar from '../navbar'
import Contact from '../Contact'
import Footer from '../Footer'

function ContactPage() {
  return (
    <>
    <Navbar/>
    <Contact/>
    <Footer/>
    </>
  )
}

export default ContactPage